import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

export function IconHome(props: Props) {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.8181 11.4024V17.9896C21.8181 20.1002 20.1687 21.8182 18.1363 21.8182H14.4545V17.1061C14.4545 16.4778 13.9439 15.9673 13.3156 15.9673H10.6843C10.0559 15.9673 9.55522 16.4778 9.55522 17.1061V21.8182H5.86358C3.83122 21.8182 2.18176 20.1002 2.18176 17.9896V11.4024C2.18176 10.2735 2.66285 9.20339 3.48758 8.46712L9.62394 3.08744C11.0083 1.87995 13.0014 1.87995 14.3759 3.08744L20.5123 8.46712C21.3469 9.20339 21.8181 10.2735 21.8181 11.4024Z"
        fill="#1FAB71"
      />
    </svg>
  );
}
